/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ng2-translate/src/translate.pipe';
import * as import2 from 'ng2-translate/src/translate.service';
import * as import3 from '../../buttons/icon-button/icon-button.component.ngfactory';
import * as import4 from '../../buttons/icon-button/icon-button.component';
import * as import5 from '@angular/common';
import * as import6 from '../../ui-elements/logo/logo.component.ngfactory';
import * as import7 from '../../ui-elements/logo/logo.component';
import * as import8 from '../../ordering-context/ordering-context.model';
import * as import9 from '../../ui-elements/image/background-image.directive';
import * as import10 from '../../ui-elements/image/cached-image.service';
import * as import11 from '../../orchestration/responsive.directive';
import * as import12 from '../../orchestration/responsive.service';
import * as import13 from '../../orchestration/navigation.service';
import * as import14 from '../../html-utils/css-var.directive';
import * as import15 from '../../legal/legal-panel/legal-panel.component.ngfactory';
import * as import16 from '../../legal/legal-panel/legal-panel.component';
import * as import17 from '../../orchestration/analytics.service';
import * as import18 from '../../notification/footer-messages/footer-messages.component.ngfactory';
import * as import19 from '../../notification/footer-messages/footer-messages.component';
import * as import20 from '../../notification/notification.service';
import * as import21 from '../../ui-elements/chewzie-logo/chewzie-logo.component.ngfactory';
import * as import22 from '../../ui-elements/chewzie-logo/chewzie-logo.component';
import * as import23 from './desktop-home-page-layout.component';
import * as import24 from '../../orchestration/page';
import * as import25 from '../../orchestration/session.model';
const styles_DesktopHomePageLayoutComponent:any[] = ([] as any[]);
export const RenderType_DesktopHomePageLayoutComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_DesktopHomePageLayoutComponent,
  data: {}
}
);
function View_DesktopHomePageLayoutComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'redirecting'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n    ',
      '\n'
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('woa.message.entry.redirecting'));
    ck(v,1,0,currVal_0);
  });
}
function View_DesktopHomePageLayoutComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'class',
        'page-header-navbar-body-menu'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.navigationService.createPage('woa-nav-menu-page',(undefined as any),{alignment: co.PageAlignment.LEFT})) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import3.View_IconButtonComponent_0,import3.RenderType_IconButtonComponent)),
    import0.ɵdid(49152,(null as any),0,import4.IconButtonComponent,([] as any[]),{
      type: [
        0,
        'type'
      ]
      ,
      disabled: [
        1,
        'disabled'
      ]

    }
    ,{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_3:any = co.IconButtonType.MENU;
    const currVal_4:boolean = !co.enableNavMenuIcon;
    ck(v,1,0,currVal_3,currVal_4);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).type;
    const currVal_1:any = import0.ɵnov(v,1).disabled;
    const currVal_2:any = import0.ɵnov(v,1).unavailable;
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
function View_DesktopHomePageLayoutComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'page-header-navbar-body-logo'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import5.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod([
      'page-scrolled',
      'with-header-image',
      'with-no-header-image'
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-logo',[[
        'class',
        'logo'
      ]
    ],(null as any),(null as any),(null as any),import6.View_LogoComponent_0,import6.RenderType_LogoComponent)),
      import0.ɵdid(49152,(null as any),0,import7.LogoComponent,[import8.OrderingContextModel],{type: [
        0,
        'type'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'page-header-navbar-body-logo';
    const currVal_1:any = ck(v,2,0,(co.scrollerTop > 0),co.hasHeaderImage,co.hasNoHeaderImage);
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_2:any = 'horizontal';
    ck(v,5,0,currVal_2);
  },(null as any));
}
function View_DesktopHomePageLayoutComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,[
      [
        3,
        0
      ]
      ,
      [
        'fullWidthHeaderNavbar',
        1
      ]

    ]
      ,(null as any),21,'div',[[
        'class',
        'page-header-navbar placement-full-width'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import5.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod([
      'page-scrolled',
      'with-header-image',
      'with-blank-header-image',
      'with-no-header-image'
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),16,'div',[[
        'class',
        'page-header-navbar-body'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DesktopHomePageLayoutComponent_5)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DesktopHomePageLayoutComponent_6)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'page-header-navbar-body-controls'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',([] as any[]),[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.onSearchMenu.emit()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import3.View_IconButtonComponent_0,import3.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import4.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',([] as any[]),[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.onRefresh.emit()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import3.View_IconButtonComponent_0,import3.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import4.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'page-header-navbar placement-full-width';
    const currVal_1:any = ck(v,2,0,(co.scrollerTop > 0),co.hasHeaderImage,co.hasBlankHeaderImage,co.hasNoHeaderImage);
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_2:boolean = !co.sessionModel.waiterMode;
    ck(v,7,0,currVal_2);
    const currVal_3:any = co.sessionModel.currentApp.showDesktopHeaderLogo;
    ck(v,10,0,currVal_3);
    const currVal_7:any = co.IconButtonType.SEARCH;
    ck(v,15,0,currVal_7);
    const currVal_11:any = co.IconButtonType.REFRESH;
    ck(v,18,0,currVal_11);
  },(ck,v) => {
    const currVal_4:any = import0.ɵnov(v,15).type;
    const currVal_5:any = import0.ɵnov(v,15).disabled;
    const currVal_6:any = import0.ɵnov(v,15).unavailable;
    ck(v,14,0,currVal_4,currVal_5,currVal_6);
    const currVal_8:any = import0.ɵnov(v,18).type;
    const currVal_9:any = import0.ɵnov(v,18).disabled;
    const currVal_10:any = import0.ɵnov(v,18).unavailable;
    ck(v,17,0,currVal_8,currVal_9,currVal_10);
  });
}
function View_DesktopHomePageLayoutComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'page-header-image-body-title-logo'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-logo',[[
        'class',
        'logo'
      ]
    ],(null as any),(null as any),(null as any),import6.View_LogoComponent_0,import6.RenderType_LogoComponent)),
      import0.ɵdid(49152,(null as any),0,import7.LogoComponent,[import8.OrderingContextModel],{type: [
        0,
        'type'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = 'horizontal';
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_DesktopHomePageLayoutComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-logo',[[
        'class',
        'page-header-image-body-page-logo logo'
      ]
    ],(null as any),(null as any),(null as any),import6.View_LogoComponent_0,import6.RenderType_LogoComponent)),
      import0.ɵdid(49152,(null as any),0,import7.LogoComponent,[import8.OrderingContextModel],{type: [
        0,
        'type'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    const currVal_0:any = 'vertical';
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_DesktopHomePageLayoutComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,[
      [
        4,
        0
      ]
      ,
      [
        'fullWidthHeaderImage',
        1
      ]

    ]
      ,(null as any),16,'div',[[
        'class',
        'page-header-image placement-full-width'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import5.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod([
      'with-navbar',
      'with-title-logo'
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'page-header-image-body'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import9.BackgroundImageDirective,[
      import0.ElementRef,
      import0.Renderer2,
      import10.CachedImageService
    ]
      ,{imageSpecs: [
        0,
        'imageSpecs'
      ]
    },(null as any)),
    import0.ɵpod([
      'image',
      'opacity',
      'classes'
    ]
    ),
    import0.ɵpod(['classes']),
    import0.ɵpad(2),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DesktopHomePageLayoutComponent_8)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DesktopHomePageLayoutComponent_9)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'page-header-image placement-full-width';
    const currVal_1:any = ck(v,2,0,co.headerImageHasNavbar,co.showHeaderImageTitleLogo);
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_2:any = ck(v,8,0,ck(v,6,0,co.orderingContextModel.headerImage,co.orderingContextModel.headerImageOpacity,'theme-header-image-color-pair'),ck(v,7,0,'theme-standard-page-header-color-pair'));
    ck(v,5,0,currVal_2);
    const currVal_3:any = co.showHeaderImageTitleLogo;
    ck(v,11,0,currVal_3);
    const currVal_4:any = co.sessionModel.currentApp.showDesktopHeaderVerticalLogo;
    ck(v,14,0,currVal_4);
  },(null as any));
}
function View_DesktopHomePageLayoutComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DesktopHomePageLayoutComponent_4)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DesktopHomePageLayoutComponent_7)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.sessionModel.currentApp.navbarPlacement === co.AppNavbarPlacement.PAGE_HEADER);
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.hasHeaderImage;
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_DesktopHomePageLayoutComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,[
      [
        6,
        0
      ]
      ,
      [
        'contentHeaderTitlebar',
        1
      ]

    ]
      ,(null as any),4,'div',[[
        'class',
        'page-container-content-titlebar'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-logo',[[
        'class',
        'logo'
      ]
    ],(null as any),(null as any),(null as any),import6.View_LogoComponent_0,import6.RenderType_LogoComponent)),
      import0.ɵdid(49152,(null as any),0,import7.LogoComponent,[import8.OrderingContextModel],{type: [
        0,
        'type'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = 'horizontal';
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_DesktopHomePageLayoutComponent_13(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'class',
        'page-header-navbar-body-menu'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.navigationService.createPage('woa-nav-menu-page',(undefined as any),{alignment: co.PageAlignment.LEFT})) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import3.View_IconButtonComponent_0,import3.RenderType_IconButtonComponent)),
    import0.ɵdid(49152,(null as any),0,import4.IconButtonComponent,([] as any[]),{
      type: [
        0,
        'type'
      ]
      ,
      disabled: [
        1,
        'disabled'
      ]

    }
    ,{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_3:any = co.IconButtonType.MENU;
    const currVal_4:boolean = !co.enableNavMenuIcon;
    ck(v,1,0,currVal_3,currVal_4);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).type;
    const currVal_1:any = import0.ɵnov(v,1).disabled;
    const currVal_2:any = import0.ɵnov(v,1).unavailable;
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
function View_DesktopHomePageLayoutComponent_14(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'page-header-navbar-body-logo'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import5.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod([
      'page-scrolled',
      'with-header-image',
      'with-no-header-image'
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-logo',[[
        'class',
        'logo'
      ]
    ],(null as any),(null as any),(null as any),import6.View_LogoComponent_0,import6.RenderType_LogoComponent)),
      import0.ɵdid(49152,(null as any),0,import7.LogoComponent,[import8.OrderingContextModel],{type: [
        0,
        'type'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'page-header-navbar-body-logo';
    const currVal_1:any = ck(v,2,0,(co.scrollerTop > 0),co.hasHeaderImage,co.hasNoHeaderImage);
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_2:any = 'horizontal';
    ck(v,5,0,currVal_2);
  },(null as any));
}
function View_DesktopHomePageLayoutComponent_12(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,[
      [
        7,
        0
      ]
      ,
      [
        'contentHeaderNavbar',
        1
      ]

    ]
      ,(null as any),21,'div',[[
        'class',
        'page-header-navbar placement-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import5.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod([
      'page-scrolled',
      'with-header-image',
      'with-blank-header-image',
      'with-no-header-image'
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),16,'div',[[
        'class',
        'page-header-navbar-body'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DesktopHomePageLayoutComponent_13)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DesktopHomePageLayoutComponent_14)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'page-header-navbar-body-controls'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',([] as any[]),[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.onSearchMenu.emit()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import3.View_IconButtonComponent_0,import3.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import4.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',([] as any[]),[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.onRefresh.emit()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import3.View_IconButtonComponent_0,import3.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import4.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'page-header-navbar placement-content';
    const currVal_1:any = ck(v,2,0,(co.scrollerTop > 0),co.hasHeaderImage,co.hasBlankHeaderImage,co.hasNoHeaderImage);
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_2:boolean = !co.sessionModel.waiterMode;
    ck(v,7,0,currVal_2);
    const currVal_3:any = co.sessionModel.currentApp.showDesktopHeaderLogo;
    ck(v,10,0,currVal_3);
    const currVal_7:any = co.IconButtonType.SEARCH;
    ck(v,15,0,currVal_7);
    const currVal_11:any = co.IconButtonType.REFRESH;
    ck(v,18,0,currVal_11);
  },(ck,v) => {
    const currVal_4:any = import0.ɵnov(v,15).type;
    const currVal_5:any = import0.ɵnov(v,15).disabled;
    const currVal_6:any = import0.ɵnov(v,15).unavailable;
    ck(v,14,0,currVal_4,currVal_5,currVal_6);
    const currVal_8:any = import0.ɵnov(v,18).type;
    const currVal_9:any = import0.ɵnov(v,18).disabled;
    const currVal_10:any = import0.ɵnov(v,18).unavailable;
    ck(v,17,0,currVal_8,currVal_9,currVal_10);
  });
}
function View_DesktopHomePageLayoutComponent_16(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'page-header-image-body-title-logo'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-logo',[[
        'class',
        'logo'
      ]
    ],(null as any),(null as any),(null as any),import6.View_LogoComponent_0,import6.RenderType_LogoComponent)),
      import0.ɵdid(49152,(null as any),0,import7.LogoComponent,[import8.OrderingContextModel],{type: [
        0,
        'type'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                            ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = 'horizontal';
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_DesktopHomePageLayoutComponent_17(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-logo',[[
        'class',
        'page-header-image-body-page-logo logo'
      ]
    ],(null as any),(null as any),(null as any),import6.View_LogoComponent_0,import6.RenderType_LogoComponent)),
      import0.ɵdid(49152,(null as any),0,import7.LogoComponent,[import8.OrderingContextModel],{type: [
        0,
        'type'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    const currVal_0:any = 'vertical';
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_DesktopHomePageLayoutComponent_15(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,[
      [
        8,
        0
      ]
      ,
      [
        'contentHeaderImage',
        1
      ]

    ]
      ,(null as any),16,'div',[[
        'class',
        'page-header-image placement-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import5.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod([
      'with-navbar',
      'with-title-logo'
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'page-header-image-body'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import9.BackgroundImageDirective,[
      import0.ElementRef,
      import0.Renderer2,
      import10.CachedImageService
    ]
      ,{imageSpecs: [
        0,
        'imageSpecs'
      ]
    },(null as any)),
    import0.ɵpod([
      'image',
      'opacity',
      'classes'
    ]
    ),
    import0.ɵpod(['classes']),
    import0.ɵpad(2),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DesktopHomePageLayoutComponent_16)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DesktopHomePageLayoutComponent_17)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'page-header-image placement-content';
    const currVal_1:any = ck(v,2,0,co.headerImageHasNavbar,co.showHeaderImageTitleLogo);
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_2:any = ck(v,8,0,ck(v,6,0,co.orderingContextModel.headerImage,co.orderingContextModel.headerImageOpacity,'theme-header-image-color-pair'),ck(v,7,0,'theme-standard-page-header-color-pair'));
    ck(v,5,0,currVal_2);
    const currVal_3:any = co.showHeaderImageTitleLogo;
    ck(v,11,0,currVal_3);
    const currVal_4:any = co.sessionModel.currentApp.showDesktopHeaderVerticalLogo;
    ck(v,14,0,currVal_4);
  },(null as any));
}
function View_DesktopHomePageLayoutComponent_11(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DesktopHomePageLayoutComponent_12)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DesktopHomePageLayoutComponent_15)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.sessionModel.currentApp.navbarPlacement === co.AppNavbarPlacement.PAGE_HEADER);
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.sessionModel.currentApp.showDesktopHeaderImage;
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_DesktopHomePageLayoutComponent_18(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'page-container-content-messages'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    import0.ɵncd((null as any),0),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(null as any),(null as any));
}
function View_DesktopHomePageLayoutComponent_19(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'page-container-content-footer-statement'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                        ',
      '\n                    '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.sessionModel.currentApp.dietaryStatement;
    ck(v,1,0,currVal_0);
  });
}
function View_DesktopHomePageLayoutComponent_21(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'class',
        'page-container-sidebar-navbar-menu'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.navigationService.createPage('woa-nav-menu-page',(undefined as any),{alignment: co.PageAlignment.RIGHT})) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import3.View_IconButtonComponent_0,import3.RenderType_IconButtonComponent)),
    import0.ɵdid(49152,(null as any),0,import4.IconButtonComponent,([] as any[]),{
      type: [
        0,
        'type'
      ]
      ,
      disabled: [
        1,
        'disabled'
      ]

    }
    ,{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_3:any = co.IconButtonType.MENU;
    const currVal_4:boolean = !co.enableNavMenuIcon;
    ck(v,1,0,currVal_3,currVal_4);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).type;
    const currVal_1:any = import0.ɵnov(v,1).disabled;
    const currVal_2:any = import0.ɵnov(v,1).unavailable;
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
  });
}
function View_DesktopHomePageLayoutComponent_20(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),15,'div',[[
        'class',
        'page-container-sidebar-navbar'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import5.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['with-full-width-header']),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DesktopHomePageLayoutComponent_21)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'page-container-sidebar-navbar-controls'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',([] as any[]),[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.onSearchMenu.emit()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import3.View_IconButtonComponent_0,import3.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import4.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',([] as any[]),[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.onRefresh.emit()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import3.View_IconButtonComponent_0,import3.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import4.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'page-container-sidebar-navbar';
    const currVal_1:any = ck(v,2,0,((co.sessionModel.currentApp.headerPlacement === co.AppHeaderPlacement.FULL_WIDTH) && co.sessionModel.currentApp.showDesktopHeaderImage));
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_2:boolean = !co.sessionModel.waiterMode;
    ck(v,5,0,currVal_2);
    const currVal_6:any = co.IconButtonType.SEARCH;
    ck(v,10,0,currVal_6);
    const currVal_10:any = co.IconButtonType.REFRESH;
    ck(v,13,0,currVal_10);
  },(ck,v) => {
    const currVal_3:any = import0.ɵnov(v,10).type;
    const currVal_4:any = import0.ɵnov(v,10).disabled;
    const currVal_5:any = import0.ɵnov(v,10).unavailable;
    ck(v,9,0,currVal_3,currVal_4,currVal_5);
    const currVal_7:any = import0.ɵnov(v,13).type;
    const currVal_8:any = import0.ɵnov(v,13).disabled;
    const currVal_9:any = import0.ɵnov(v,13).unavailable;
    ck(v,12,0,currVal_7,currVal_8,currVal_9);
  });
}
function View_DesktopHomePageLayoutComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,[
      [
        1,
        0
      ]
      ,
      [
        'scroller',
        1
      ]

    ]
    ,(null as any),108,'div',[
      [
        'class',
        'scroller'
      ]
      ,
      [
        'woa-responsive',
        ''
      ]

    ]
      ,(null as any),[[
        (null as any),
        'scroll'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('scroll' === en)) {
        const pd_0:any = ((<any>co.scrolling()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(737280,(null as any),0,import11.ResponsiveDirective,[
      import0.ElementRef,
      import12.ResponsiveService,
      import13.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),104,'div',[
      [
        'class',
        'page'
      ]
      ,
      [
        'woa-responsive',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import5.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['sidebar-fixed']),
      import0.ɵdid(671744,(null as any),0,import14.CssVarDirective,[import0.ElementRef],{cssVars: [
        0,
        'cssVars'
      ]
    },(null as any)),
    import0.ɵpod([
      '--scroller-scrollbar-width',
      '--content-width'
    ]
    ),
    import0.ɵdid(737280,(null as any),0,import11.ResponsiveDirective,[
      import0.ElementRef,
      import12.ResponsiveService,
      import13.NavigationService,
      import0.ChangeDetectorRef,
      import0.Renderer2
    ]
      ,{pillarboxedOnDesktop: [
        0,
        'pillarboxedOnDesktop'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DesktopHomePageLayoutComponent_3)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,[
      [
        2,
        0
      ]
      ,
      [
        'container',
        1
      ]

    ]
      ,(null as any),93,'div',[[
        'class',
        'page-container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,[
      [
        5,
        0
      ]
      ,
      [
        'content',
        1
      ]

    ]
      ,(null as any),45,'div',[[
        'class',
        'page-container-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DesktopHomePageLayoutComponent_10)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DesktopHomePageLayoutComponent_11)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DesktopHomePageLayoutComponent_18)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'page-container-content-header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    import0.ɵncd((null as any),1),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,[
      [
        9,
        0
      ]
      ,
      [
        'contentBody',
        1
      ]

    ]
      ,(null as any),19,'div',[[
        'class',
        'page-container-content-body'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,[[
        'contentBodySelector',
        1
      ]
      ],(null as any),3,'div',[[
        'class',
        'page-container-content-body-selector'
      ]
      ],[[
        4,
        'top',
        (null as any)
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    import0.ɵncd((null as any),2),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'page-container-content-body-details'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,[[
        'contentBodyDetailsHeader',
        1
      ]
      ],(null as any),3,'div',[[
        'class',
        'page-container-content-body-details-header'
      ]
      ],[[
        4,
        'top',
        (null as any)
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    import0.ɵncd((null as any),3),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,[[
        'contentBodyDetailsMain',
        1
      ]
      ],(null as any),3,'div',[[
        'class',
        'page-container-content-body-details-main'
      ]
      ],[[
        4,
        'top',
        (null as any)
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    import0.ɵncd((null as any),4),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,[
      [
        10,
        0
      ]
      ,
      [
        'contentFooter',
        1
      ]

    ]
      ,(null as any),7,'div',[[
        'class',
        'page-container-content-footer'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DesktopHomePageLayoutComponent_19)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-legal-panel',[[
        'class',
        'page-container-content-footer-links'
      ]
    ],(null as any),(null as any),(null as any),import15.View_LegalPanelComponent_0,import15.RenderType_LegalPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import16.LegalPanelComponent,[
      import17.AnalyticsService,
      import13.NavigationService
    ]
    ,{
      messageSet: [
        0,
        'messageSet'
      ]
      ,
      showFeedback: [
        1,
        'showFeedback'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,[
      [
        12,
        0
      ]
      ,
      [
        'sidebarPlaceholder',
        1
      ]

    ]
      ,(null as any),1,'div',[[
        'class',
        'page-container-sidebar-placeholder'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,[
      [
        11,
        0
      ]
      ,
      [
        'sidebar',
        1
      ]

    ]
      ,(null as any),40,'div',[[
        'class',
        'page-container-sidebar'
      ]
    ],(null as any),[
      [
        (null as any),
        'wheel'
      ]
      ,
      [
        (null as any),
        'touchstart'
      ]
      ,
      [
        (null as any),
        'touchmove'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('wheel' === en)) {
        const pd_0:any = ((<any>co.scrollByWheel($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('touchstart' === en)) {
        const pd_1:any = ((<any>co.scrollByTouchStart($event)) !== false);
        ad = (pd_1 && ad);
      }
      if (('touchmove' === en)) {
        const pd_2:any = ((<any>co.scrollByTouchMove($event)) !== false);
        ad = (pd_2 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import5.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['with-navbar']),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DesktopHomePageLayoutComponent_20)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),32,'div',[[
        'class',
        'page-container-sidebar-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'page-container-sidebar-content-header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    import0.ɵncd((null as any),5),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'page-container-sidebar-content-body'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    import0.ɵncd((null as any),6),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'woa-footer-messages',([] as any[]),(null as any),(null as any),(null as any),import18.View_FooterMessagesComponent_0,import18.RenderType_FooterMessagesComponent)),
    import0.ɵdid(49152,(null as any),0,import19.FooterMessagesComponent,[
      import20.NotificationService,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    import0.ɵncd(1,7),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'page-container-sidebar-content-footer'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    import0.ɵncd((null as any),8),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    import0.ɵncd((null as any),9),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    import0.ɵncd((null as any),10),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'page-container-sidebar-content-footer-logo'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-chewzie-logo',([] as any[]),(null as any),(null as any),(null as any),import21.View_ChewzieLogoComponent_0,import21.RenderType_ChewzieLogoComponent)),
    import0.ɵdid(49152,(null as any),0,import22.ChewzieLogoComponent,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    ck(v,1,0);
    const currVal_0:any = 'page';
    const currVal_1:any = ck(v,5,0,(co.sidebarPosition === 'fixed'));
    ck(v,4,0,currVal_0,currVal_1);
    const currVal_2:any = ck(v,7,0,co.scrollerScrollbarWidth,co.contentWidth);
    ck(v,6,0,currVal_2);
    const currVal_3:any = 'desktop';
    ck(v,8,0,currVal_3);
    const currVal_4:any = (co.sessionModel.currentApp.headerPlacement === co.AppHeaderPlacement.FULL_WIDTH);
    ck(v,11,0,currVal_4);
    const currVal_5:any = co.showContentHeaderTitlebar;
    ck(v,18,0,currVal_5);
    const currVal_6:any = (co.sessionModel.currentApp.headerPlacement === co.AppHeaderPlacement.CONTENT);
    ck(v,21,0,currVal_6);
    const currVal_7:any = ((co.contentMessages == null)? (null as any): co.contentMessages.length);
    ck(v,24,0,currVal_7);
    const currVal_11:any = co.sessionModel.currentApp.dietaryStatement;
    ck(v,55,0,currVal_11);
    const currVal_12:any = 'nav-menu';
    const currVal_13:any = (co.sessionModel.currentApp.feedbackCategories.length > 0);
    ck(v,58,0,currVal_12,currVal_13);
    const currVal_14:any = 'page-container-sidebar';
    const currVal_15:any = ck(v,67,0,co.showSidebarNavbar);
    ck(v,66,0,currVal_14,currVal_15);
    const currVal_16:any = co.showSidebarNavbar;
    ck(v,70,0,currVal_16);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.contentStickyTop(import0.ɵnov(v,33));
    ck(v,33,0,currVal_8);
    const currVal_9:any = co.contentStickyTop(import0.ɵnov(v,40));
    ck(v,40,0,currVal_9);
    const currVal_10:any = co.contentStickyTop(import0.ɵnov(v,45));
    ck(v,45,0,currVal_10);
  });
}
export function View_DesktopHomePageLayoutComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(671088640,1,{scrollerER: 0}),
    import0.ɵqud(671088640,2,{containerER: 0}),
    import0.ɵqud(671088640,3,{fullWidthHeaderNavbarER: 0}),
    import0.ɵqud(671088640,4,{fullWidthHeaderImageER: 0}),
    import0.ɵqud(671088640,5,{contentER: 0}),
    import0.ɵqud(671088640,6,{contentHeaderTitlebarER: 0}),
    import0.ɵqud(671088640,7,{contentHeaderNavbarER: 0}),
    import0.ɵqud(671088640,8,{contentHeaderImageER: 0}),
    import0.ɵqud(671088640,9,{contentBodyER: 0}),
    import0.ɵqud(671088640,10,{contentFooterER: 0}),
    import0.ɵqud(671088640,11,{sidebarER: 0}),
    import0.ɵqud(671088640,12,{sidebarPlaceholderER: 0}),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_DesktopHomePageLayoutComponent_1)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import5.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_DesktopHomePageLayoutComponent_2)),
    import0.ɵdid(16384,(null as any),0,import5.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import0.ɵpid(131072,import5.AsyncPipe,[import0.ChangeDetectorRef]),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import23.DesktopHomePageLayoutComponent = v.component;
    const currVal_0:any = import0.ɵunv(v,13,0,import0.ɵnov(v,14).transform(co.OrchestrationEvents.redirecting$));
    ck(v,13,0,currVal_0);
    const currVal_1:boolean = !import0.ɵunv(v,17,0,import0.ɵnov(v,18).transform(co.OrchestrationEvents.redirecting$));
    ck(v,17,0,currVal_1);
  },(null as any));
}
function View_DesktopHomePageLayoutComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'woa-desktop-home-page-layout',([] as any[]),(null as any),(null as any),(null as any),View_DesktopHomePageLayoutComponent_0,RenderType_DesktopHomePageLayoutComponent)),
    import0.ɵdid(245760,(null as any),1,import23.DesktopHomePageLayoutComponent,[
      import24.Page,
      import25.SessionModel,
      import13.NavigationService,
      import8.OrderingContextModel,
      import0.ChangeDetectorRef,
      import12.ResponsiveService
    ]
    ,(null as any),(null as any)),
    import0.ɵqud(603979776,1,{contentMessages: 1}),
    import0.ɵprd(6144,(null as any),import24.PageLayout,(null as any),[import23.DesktopHomePageLayoutComponent])
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const DesktopHomePageLayoutComponentNgFactory:import0.ComponentFactory<import23.DesktopHomePageLayoutComponent> = import0.ɵccf('woa-desktop-home-page-layout',import23.DesktopHomePageLayoutComponent,View_DesktopHomePageLayoutComponent_Host_0,{enableNavMenuIcon: 'enableNavMenuIcon'},{
  onRefresh: 'onRefresh',
  onSearchMenu: 'onSearchMenu'
}
,[
  'woa-content-message',
  '[slot=content-header]',
  '[slot=content-selector]',
  '[slot=content-details-header]',
  '[slot=content-details-main]',
  '[slot=sidebar-header]',
  '[slot=sidebar-body]',
  'woa-footer-message, [slot=footer-messages]',
  '[slot=sidebar-footer-start]',
  '[woa-page-footer-control]',
  '[slot=sidebar-footer-end]'
]
);
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/page-layout/desktop-home-page-layout/desktop-home-page-layout.component.ngfactory.ts